export default {"src":"/_next/static/media/6.cfcf2def.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};